<span>{{timeFormat}}</span>